import React from 'react';

import { cn } from '@lyearn/style';
import { Typography } from '@lyearn/ui';

type TableHeaderProps = {
  text: string;
  className?: string;
};

function TableHeader(props: TableHeaderProps) {
  const { text, className } = props;

  return (
    <Typography
      className={cn('truncate', className)}
      color="text-text-placeholder"
      variant="label-caps">
      {text}
    </Typography>
  );
}

export default React.memo(TableHeader);
